import type { UserModule } from '~/types'

// https://vuejs.org/api/application.html#app-config-performance
// Will only be active in development mode
export const install: UserModule = ({ app }) => {
  app.config.performance = true
}
